import { useStore } from 'vuex'
export default function notAuth(to, from, next) {
    const store = useStore()
    store.dispatch("readToken");
    if (store.state.auth){
        next('dashboard')
    }else {
        next()
    }

  }